const timeSensitiveBanner = $('#timeSensitiveBanner');

function smoothScrollToValue(top, left) {
    window.scrollTo({
        top: top, //- number
        left: left, //- number
        behavior: 'smooth'
    });
}

smoothScrollToValue(0, 0);

if (timeSensitiveBanner.length) {

    $('#timeSensitiveBanner, .btn:not(.cta, .btn--noScrollTo)').on('click', function (event) {
        let headerHeight = Math.floor($('header').outerHeight());
        let timeSensitiveBannerHeight = Math.floor($('#timeSensitiveBanner').outerHeight());

        if ($('body').hasClass('show-timeSensitiveBanner')) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top - timeSensitiveBannerHeight - headerHeight
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        }
    });

    /**
     * Time Sensitive Banner
     * ------------------------------------------
     * Add Duration Cookie with 15min expiration
     * Add Reset Cookie to show the banner again
     * Start countdown
     * calc countdown if page reload and restart it
     */

    let durationExpires = new Date(new Date().getTime() + durationMinutes * 60 * 1000); //- minutes
    let resetTimeExpires = new Date(new Date().getTime() + resetTimeHours * 60 * 60 * 1000); //- hours
    // let resetTimeExpires = new Date(new Date().getTime() + resetTimeHours * 60 * 1000); //- minutes to easily test the feature
    let timeSensitiveBannerStart = new Date(new Date().getTime()).toUTCString();
    let timeSensitiveBannerDuration = durationExpires.toUTCString();
    
    // console.log('now Date', new Date(new Date().getTime()));
    // console.log('durationMinutes', durationMinutes);
    // console.log('durationExpires', durationExpires);
    // console.log('resetTimeHours', resetTimeHours);
    // console.log('resetTimeExpires', resetTimeExpires);
    // console.log('timeSensitiveBannerStart', timeSensitiveBannerStart);
    // console.log('timeSensitiveBannerDuration', timeSensitiveBannerDuration);

    //- Support different pages with different durations
    let timeSensitiveBannerDurationCookie = 'timeSensitiveBannerDurationFor' + durationMinutes + 'min',
        timeSensitiveBannerResetCookie = 'timeSensitiveBannerResetFor' + durationMinutes + 'min',
        timeSensitiveBannerNewStartCookie = 'timeSensitiveBannerNewStartFor' + durationMinutes + 'min';

    // console.log('timeSensitiveBannerDurationCookie ' + timeSensitiveBannerDurationCookie);
    // console.log('timeSensitiveBannerResetCookie ' + timeSensitiveBannerResetCookie);
    // console.log('timeSensitiveBannerNewStartCookie ' + timeSensitiveBannerNewStartCookie);

    /**
     * 1. Re-run countdown if reload page within duration on based on diff calculation
     * 
     * 2. Add cookies duration and reset and storage current time if cookies doesn't exist
     * 
     * 3. Remove local storage with starting time if duration expired but reset didn't yet 
     */
    if ($.cookie(timeSensitiveBannerDurationCookie) && $.cookie(timeSensitiveBannerResetCookie)) {
        localStorage.setItem(timeSensitiveBannerNewStartCookie, timeSensitiveBannerStart);

        let calcDiffTime = {
            newStart: localStorage.getItem(timeSensitiveBannerNewStartCookie),
            duration: localStorage.getItem(timeSensitiveBannerDurationCookie)
        }
        
        // console.log('>> timeSensitiveBannerNewStart', calcDiffTime.newStart, Date.parse(calcDiffTime.newStart));
        // console.log('>> timeSensitiveBannerDuration', calcDiffTime.duration, Date.parse(calcDiffTime.duration));

        let diffTime = (Date.parse(calcDiffTime.duration) - Date.parse(calcDiffTime.newStart)),

            diffMinutes = Math.floor((diffTime / 1000 / 60) % 60),
            diffSeconds = Math.floor((diffTime / 1000) % 60);

        // console.log('>> diffTime', diffTime);
        // console.log('>> diffMinutes', diffMinutes);
        // console.log('>> diffSeconds', diffSeconds);

        setActiveTimer(diffMinutes, diffSeconds);
        
        $('.cart__product.active').trigger("click");

    } else if (!$.cookie(timeSensitiveBannerDurationCookie) && !$.cookie(timeSensitiveBannerResetCookie)) {
        setActiveTimer(durationMinutes, 0);

        $('.cart__product.active').trigger("click");

        $.cookie(timeSensitiveBannerDurationCookie, 1, { expires: durationExpires });
        $.cookie(timeSensitiveBannerResetCookie, 1, { expires: resetTimeExpires });

        localStorage.setItem(timeSensitiveBannerDurationCookie, timeSensitiveBannerDuration);

    } else if (!$.cookie(timeSensitiveBannerDurationCookie) && $.cookie(timeSensitiveBannerResetCookie)) {
        localStorage.removeItem(timeSensitiveBannerDurationCookie);
        localStorage.removeItem(timeSensitiveBannerNewStartCookie);

    }

    /**
     * Change Layout on Scroll
     */
    function adjustHeader() {
        const bannerHeight = $('#timeSensitiveBanner').outerHeight();

        if ($(window).scrollTop() > bannerHeight) {
            $(".timeSensitiveBanner:not(.timeSensitiveBanner--compact)").addClass("timeSensitiveBanner--compact");

        } else if ($(window).scrollTop() < 200) {
            $(".timeSensitiveBanner").removeClass("timeSensitiveBanner--compact");

        }
    }

    adjustHeader();

    $(window).on('scroll', adjustHeader);
}